import { render, staticRenderFns } from "./popUp.vue?vue&type=template&id=156444bb&scoped=true&"
import script from "./popUp.vue?vue&type=script&lang=js&"
export * from "./popUp.vue?vue&type=script&lang=js&"
import style0 from "./popUp.vue?vue&type=style&index=0&id=156444bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156444bb",
  null
  
)

/* custom blocks */
import block0 from "./popUp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports